import React from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import NavBar from '../Landing2/NavBar';
import Footer from '../Landing2/Footer';
import Seo from '../Seo/Seo';
import { SITE_URL } from '../../constants';
import './Blog.css';

const BlogPost = ({ posts }) => {
  const { slug } = useParams();
  const post = posts.find(p => p.slug === slug);

  if (!post) {
    return (
      <div>
        <Seo title="Post not found | Screenplayer" noindex />
        <NavBar />
        <div className="blog-post-container">Post not found</div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Seo
        title={`${post.title} | Screenplayer Blog`}
        description={post.description}
        path={`/blog/${post.slug}`}
        image={post.coverImage}
        type="article"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'BlogPosting',
          headline: post.title,
          description: post.description,
          datePublished: post.date,
          image: `${SITE_URL}${post.coverImage || '/logo512.png'}`,
          url: `${SITE_URL}/blog/${post.slug}`,
          author: post.authorTitle
            ? { '@type': 'Person', name: post.author, jobTitle: post.authorTitle }
            : { '@type': 'Organization', name: post.author },
          publisher: { '@type': 'Organization', name: 'Screenplayer', logo: { '@type': 'ImageObject', url: `${SITE_URL}/logo512.png` } },
        }}
      />
      <NavBar />
      <article className="blog-post-container">
        {post.coverImage && (
          <div className="blog-post-header-image">
            <img src={post.coverImage} alt={post.title} />
          </div>
        )}
        <div className="blog-post-content">
          <h1>{post.title}</h1>
          <div className="blog-post-meta">
            <span className="blog-date">{new Date(post.date).toLocaleDateString()}</span>
            {post.author && <span className="blog-author">By {post.author}{post.authorTitle && `, ${post.authorTitle}`}</span>}
          </div>
          <div className="blog-post-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {post.content}
            </ReactMarkdown>
          </div>
        </div>
      </article>
      <Footer />
    </div>
  );
};

export default BlogPost; 